import styled from 'styled-components';

export const Details = styled.div`
  box-shadow: 0px 16px 30px #f1eaea13;
  border-radius: 12px;
  width: 36%;
  margin-left: 35%;
  margin-top: 2%;
  padding: 2em;
  background-color: white;
  text-align: center;
  svg {
    margin-right: 80%;
  }
  img {
    width: 250px;
    height: 315px;
    object-fit: cover;
  }
`;
